var agency = {
    text1:"BIENVENIDO A REGISTRO DE AGENCIA",   
    text2:"Registra tu agencia para continuar dentro del programa.",
    text3:"¿Necesitas registrar un agente? Haz clic aquí.",
    successTitle: "Agencia registrada correctamente",
    successText: "La agencia se creó correctamente. Desde este flujo ya no se muestra un panel administrativo para continuar. Si quieres seguir ahora mismo, puedes registrar un agente para esta agencia.",
    successPrimaryAction: "Registrar agente",
    successSecondaryAction: "Registrar otra agencia",
    create: {
      buttonText: "Registrar agencia",
      title: "Registrar agencia",
      agencyNameRequired: "El nombre de la agencia es obligatorio.",
      addressRequired: "La dirección es obligatoria.",
      primaryPhoneRequired: "El teléfono principal es obligatorio.",
      cityRequired: "La ciudad es obligatoria.",
      contactNameRequired: "El nombre del contacto es obligatorio.",
      contactLastNameRequired: "El apellido del contacto es obligatorio.",
      emailRequired: "El email es obligatorio.",
      passwordRequired: "La contraseña es obligatoria.",
      passwordMismatch: "Las contraseñas no coinciden.",
      termsRequired: "Debes aceptar los términos.",
      countryRequired: "El país es obligatorio.",
      stateRequired: "El estado es obligatorio.",
      countryLoadError: "No se pudieron cargar los países.",
      stateLoadError: "No se pudieron cargar los estados.",
      submitError: "No se pudo crear la agencia.",
      agencyNameLabel: "Nombre de la agencia",
      agencyNamePlaceholder: "Ej. Agencia Sol Travel",
      agencyTypeLabel: "Tipo de agencia",
      primaryPhoneLabel: "Teléfono principal",
      secondaryPhoneLabel: "Teléfono secundario",
      addressLabel: "Dirección",
      addressPlaceholder: "Escribe la dirección",
      address2Label: "Dirección 2",
      agencySectionLabel: "Datos de la agencia",
      agencySectionHelp: "Comienza con la información principal de la agencia.",
      contactSectionLabel: "Contacto principal",
      contactSectionHelp: "Agrega a la persona principal de contacto para esta agencia.",
      locationSectionLabel: "Ubicación",
      locationSectionHelp: "Indícanos dónde se encuentra la agencia.",
      accessSectionLabel: "Acceso",
      accessSectionHelp: "Crea la contraseña de acceso para esta agencia.",
      cityLabel: "Ciudad",
      zipCodeLabel: "Código postal",
      stateLabel: "Estado",
      stateIdLabel: "Estado ID",
      countryLabel: "País",
      countryIdLabel: "País ID",
      selectCountryLabel: "Selecciona un país",
      selectStateLabel: "Selecciona un estado",
      selectCountryFirstLabel: "Selecciona primero un país",
      loadingCountriesLabel: "Cargando países...",
      loadingStatesLabel: "Cargando estados...",
      contactNameLabel: "Nombre contacto",
      contactLastNameLabel: "Apellido contacto",
      contactTitleLabel: "Puesto",
      emailLabel: "Email",
      passwordLabel: "Password",
      confirmPasswordLabel: "Confirmar password",
      mobileAppNameLabel: "Mobile App Name",
      registrationTypeLabel: "Registration Type",
      marivalRewardsLabel: "Marival Rewards",
      branchAgencyLabel: "Es branch agency",
      hasHqLabel: "Tiene HQ",
      termsTextBefore: "He leído y acepto los términos y condiciones para el uso del ",
      termsLinkText: "material multimedia de Marival Resorts",
      termsTextAfter: ".",
      policiesRequired: "Debes aceptar el Aviso de Privacidad y la Política de Cookies.",
      policiesTextBefore: "He leído y acepto los términos del ",
      policiesPrivacyLink: "Aviso de Privacidad",
      policiesTextMiddle: " y la ",
      policiesCookieLink: "Política de Cookies",
      policiesTextAfter: ".",
      cancelButton: "Cancelar",
      submittingButton: "Creando...",
      submitButton: "Guardar / Crear agencia"
    }
}
module.exports = agency
